import React, { PureComponent } from 'react';

import PropTypes from 'prop-types';

class AccessSelectDateHeader extends PureComponent {
  static propTypes = {
    periodList: PropTypes.array,
    setCheck: PropTypes.func,
    field: PropTypes.string
  };

  render() {
    const { periodList, setCheck, field } = this.props;

    return (
      <form>
        {periodList.map((period) => (
          <div
            key={`${field}_${period.value}`}
            className="access__select__date__options"
          >
            <input
              type="radio"
              name={period.value}
              checked={period.checked}
              onChange={setCheck}
            />

            <div className="access__select__date__label">{period.label}</div>
          </div>
        ))}
      </form>
    );
  }
}

export default AccessSelectDateHeader;
